import { useRef, useEffect, useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import styles from'./FilterMenu.module.css'
import { FaTimes } from "react-icons/fa";
import {MdKeyboardArrowUp} from "react-icons/md";
import {MdKeyboardArrowDown} from "react-icons/md";

export default function FilterMenu({ episodes, setTitleFilter, setScriptureFilter, setPreacherFilter }) {

    const dropdownRef = useRef();

  // Initialize state variables
  const [titleArray, setTitleArray] = useState([]);
  const [scriptureArray, setScriptureArray] = useState([]);
  const [preacherArray, setPreacherArray] = useState([]);
  const [filter, setFilter] = useState('');
  const [isArrow, setIsArrow] = useState(true);


  // Fill the Sets used to make the filter dropdowns
  const createFilters = (episodes) => {
    const titleSet = new Set();
    const preacherSet = new Set();
    const scriptureSet = new Set();

    episodes.forEach((episode) => {
        titleSet.add(episode.title);
        scriptureSet.add(episode.scripture);
        preacherSet.add(episode.preacher);
    });

    // Convert Sets to Arrays and update state
    setTitleArray(Array.from(titleSet).sort());
    setScriptureArray(Array.from(scriptureSet).sort());
    setPreacherArray(Array.from(preacherSet).sort());
  };

  const handleClick = (filter, filterType) => {
    if(filterType === 'title'){
        setTitleFilter(filter);
        setScriptureFilter('');
        setPreacherFilter('');
        hanldeMobilMenuDrop(); //Closes the mobile menu again
    } else if (filterType === 'scripture'){
        setTitleFilter('');
        setScriptureFilter(filter);
        setPreacherFilter('');
        hanldeMobilMenuDrop();
    } else if ( filterType === 'preacher'){
        setTitleFilter('');
        setScriptureFilter('');
        setPreacherFilter(filter);
        hanldeMobilMenuDrop();
    } else {
        setTitleFilter('');
        setScriptureFilter('');
        setPreacherFilter('');
    }
    setFilter(filter);
  }

  //Toggles between opening and closing the mobile menu
  // And if the arrow is up(false) or down(true)
  const hanldeMobilMenuDrop = () => {
    dropdownRef.current.classList.toggle(styles.filterdropdownMenuWrapperExpanded);
    setIsArrow(!isArrow)
  }

  // Call createFilters when episodes prop changes
  useEffect(() => {
    createFilters(episodes);
  }, [episodes]);

  useEffect(() => {
    titleArray.sort((a, b) => a.localeCompare(b));
    scriptureArray.sort((a, b) => a.localeCompare(b));
    preacherArray.sort((a, b) => a.localeCompare(b));
  }, [titleArray, scriptureArray,preacherArray]);

  return (
    <div className={styles.filterWrapper}>
        <div className={styles.mobileFilterDropdownMenu}>
            <div ref={dropdownRef} className={styles.filterdropdownMenuWrapper}>
                <Dropdown className={styles.filterDropdown}>

                    <Dropdown.Toggle 
                        drop = 'up'
                        variant="secondary" 
                        className={styles.dropdownBasic}>
                        Emne
                    </Dropdown.Toggle>

                    <Dropdown.Menu className={styles.filterDropdownMenu}>
                        {titleArray.length > 0 ? (
                            titleArray.map((title) => (
                            <Dropdown.Item 
                                className={styles.dropdownItems} 
                                key={title} 
                                onClick= {() => handleClick(title, 'title')}>
                            {title}
                            </Dropdown.Item>
                            ))
                        ) : (
                            <Dropdown.Item className={styles.dropdownItems}>Ingen filter</Dropdown.Item>
                        )}
                    </Dropdown.Menu>
                </Dropdown>

                <Dropdown className={styles.filterDropdown}>
                    <Dropdown.Toggle 
                        variant="secondary" 
                        className={styles.dropdownBasic}>
                    Skriftsted
                    </Dropdown.Toggle>

                    <Dropdown.Menu className={styles.filterDropdownMenu}>
                        {scriptureArray.length > 0 ? (
                            scriptureArray.map((scripture) => (
                            <Dropdown.Item 
                                className={styles.dropdownItems} 
                                key={scripture} 
                                onClick={() => handleClick(scripture, 'scripture')}>
                                    {scripture}
                            </Dropdown.Item>
                            ))
                        ) : (
                            <Dropdown.Item className={styles.dropdownItems}>Ingen filter</Dropdown.Item>
                        )}
                    </Dropdown.Menu>
                </Dropdown>

                <Dropdown className={styles.filterDropdown}>
                    <Dropdown.Toggle 
                        variant="secondary" 
                        className={styles.dropdownBasic}>
                    Prædikant
                    </Dropdown.Toggle >

                    <Dropdown.Menu className={styles.filterDropdownMenu}>
                        {preacherArray.length > 0 ? (
                            preacherArray.map((preacher) => (
                            <Dropdown.Item 
                                className={styles.dropdownItems} 
                                key={preacher} 
                                onClick={() => handleClick(preacher, 'preacher')}>
                                    {preacher}
                            </Dropdown.Item>
                            ))
                        ) : (
                            <Dropdown.Item className={styles.dropdownItems}>Ingen filter</Dropdown.Item>
                        )}
                    </Dropdown.Menu>

                </Dropdown>
            </div>
                <div onClick={() => hanldeMobilMenuDrop()} className={styles.filterDropdownIndicator}>
                    <h3 style={{marginBottom: '0px'}}>Vælg Filter</h3>
                    {isArrow ? 
                        (<MdKeyboardArrowDown className={styles.arrow} ></MdKeyboardArrowDown>) 
                        : 
                        (<MdKeyboardArrowUp className={styles.arrow} ></MdKeyboardArrowUp>)}
                </div>
        </div>
            {filter !== '' ? (
                    <div className={styles.showFilter}>
                        <h2 className={styles.filterTitle}><span style={{color: "gray"}}>Filter : </span>{filter}</h2>
                        <button className={styles.closeBnt} onClick={() => handleClick('','')} ><FaTimes className={styles.close}/></button>
                    </div>
                    ) : (
                        <></>
                    )}
        
    </div>
  );
}